"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _FlexContainer = _interopRequireDefault(require("../../FlexContainer"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _PhoneInput = require("./PhoneInput.config");

var _selectStyles = _interopRequireDefault(require("../styles/selectStyles"));

var _Flag = require("../../Flag/Flag");

var _templateObject, _templateObject2;

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var phoneSelectorStyles = _objectSpread(_objectSpread({}, _selectStyles.default), {}, {
  container: function container(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      minWidth: '9.5rem'
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      minWidth: 'unset',
      width: 'auto'
    });
  }
});

var getValidationsArray = function getValidationsArray(dependencies, options, value, validations, validationDependency) {
  var _dependencies$validat;

  var validationDepKey,
      validationDepValue = {};

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies !== null && dependencies !== void 0 && (_dependencies$validat = dependencies[validationDepKey]) !== null && _dependencies$validat !== void 0 && _dependencies$validat[validationDepValue] ? !value ? [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations : validations;
  if (options !== null && options !== void 0 && options.subType && !validationsArray.includes(options.subType)) validationsArray.push(options.subType);
  return validationsArray;
};

var PhoneInput = function PhoneInput(_ref) {
  var _prefixOption3;

  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? [] : _ref$validations,
      isFirstInput = _ref.isFirstInput,
      dependencies = _ref.dependencies,
      validationDependency = _ref.validationDependency,
      errorHandler = _ref.errorHandler,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      options = _ref.options,
      _ref$customLabel = _ref.customLabel,
      customLabel = _ref$customLabel === void 0 ? false : _ref$customLabel,
      _ref$handleKeyPress = _ref.handleKeyPress,
      handleKeyPress = _ref$handleKeyPress === void 0 ? function () {} : _ref$handleKeyPress,
      _ref$customValidation = _ref.customValidations,
      customValidations = _ref$customValidation === void 0 ? {} : _ref$customValidation,
      noFocus = _ref.noFocus,
      postErrors = _ref.postErrors,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip,
      t = _ref.t;

  var _parsePhoneNumber = (0, _PhoneInput.parsePhoneNumber)(value),
      prefix = _parsePhoneNumber.prefix,
      number = _parsePhoneNumber.number,
      region = _parsePhoneNumber.region;

  var prefixOption = _PhoneInput.PHONE_PREFIX_OPTIONS === null || _PhoneInput.PHONE_PREFIX_OPTIONS === void 0 ? void 0 : _PhoneInput.PHONE_PREFIX_OPTIONS.find(function (option) {
    var _option$value;

    return ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.toUpperCase()) === region;
  }); // Prefix needs to be different than +1 to use it to infer a country prefix, because lots of countries
  // have same prefix and we would always show same flag. Better to let the user choose any country flag.

  if (!prefixOption && prefix !== 1 && prefix !== '1') {
    prefixOption = _PhoneInput.PHONE_PREFIX_OPTIONS === null || _PhoneInput.PHONE_PREFIX_OPTIONS === void 0 ? void 0 : _PhoneInput.PHONE_PREFIX_OPTIONS.find(function (option) {
      return option.label === "+".concat(prefix);
    });
  }

  var validationsArray = getValidationsArray(dependencies, options, value, validations, validationDependency);

  var getOptionLabel = function getOptionLabel(label) {
    var _label$split;

    return (label === null || label === void 0 ? void 0 : (_label$split = label.split('-')) === null || _label$split === void 0 ? void 0 : _label$split[0]) || '';
  };

  var handlePrefixChange = function handlePrefixChange(option) {
    return onChange(id, "".concat(getOptionLabel(option === null || option === void 0 ? void 0 : option.label)).concat(number));
  };

  var handleNumberChange = function handleNumberChange(e) {
    var _prefixOption;

    var numberPrefix = prefix ? "+".concat(prefix) : (_prefixOption = prefixOption) === null || _prefixOption === void 0 ? void 0 : _prefixOption.label;
    onChange(id, "".concat(numberPrefix || '').concat(e.target.value || ''));
  };

  var inputValidation = function inputValidation(valueToCheck) {
    _validateInput.default && (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDependency,
      errorHandler: errorHandler,
      dependencies: dependencies,
      customValidations: customValidations,
      id: id
    });
  };

  (0, _react.useEffect)(function () {
    inputValidation(value);
  }, [value]);
  (0, _react.useEffect)(function () {
    var _prefixOption2;

    ((_prefixOption2 = prefixOption) === null || _prefixOption2 === void 0 ? void 0 : _prefixOption2.label) && handlePrefixChange(prefixOption);
  }, [(_prefixOption3 = prefixOption) === null || _prefixOption3 === void 0 ? void 0 : _prefixOption3.label]);
  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_FlexContainer.default, null, _react.default.createElement(_reactSelect.default, {
    isClearable: true,
    isDisabled: disabled,
    value: prefixOption,
    placeholder: "Prefix",
    options: _PhoneInput.PHONE_PREFIX_OPTIONS,
    styles: phoneSelectorStyles,
    onChange: handlePrefixChange,
    formatOptionLabel: function formatOptionLabel(option) {
      return _react.default.createElement(_FlexContainer.default, {
        alignItems: "center",
        gap: "1rem"
      }, _react.default.createElement(_Flag.Flag, {
        country: option === null || option === void 0 ? void 0 : option.code
      }), _react.default.createElement(StyledPrefixCountry, null, option === null || option === void 0 ? void 0 : option.value), _react.default.createElement(StyledPrefixNumber, null, getOptionLabel(option === null || option === void 0 ? void 0 : option.label)));
    },
    components: {
      ValueContainer: function ValueContainer(_ref2) {
        var _props$getValue;

        var children = _ref2.children,
            props = _objectWithoutProperties(_ref2, _excluded);

        var hasValue = props.hasValue;
        var option = (_props$getValue = props.getValue()) === null || _props$getValue === void 0 ? void 0 : _props$getValue[0];

        if (!hasValue || !option) {
          return _react.default.createElement(_reactSelect.components.ValueContainer, props, children);
        }

        return _react.default.createElement(_reactSelect.components.ValueContainer, props, _react.default.createElement(_FlexContainer.default, {
          alignItems: "center",
          justifyContent: "center"
        }, _react.default.createElement(_Flag.Flag, {
          country: option === null || option === void 0 ? void 0 : option.value
        }), _react.default.createElement(StyledPrefixNumber, null, getOptionLabel(option === null || option === void 0 ? void 0 : option.label))));
      }
    }
  }), _react.default.createElement(_Input.default, {
    id: id,
    disabled: disabled,
    type: "number",
    autoFocus: isFirstInput && !noFocus,
    style: {
      marginBottom: 0
    },
    value: number,
    onChange: handleNumberChange,
    onWheel: function onWheel(e) {
      var _e$target, _e$target$blur;

      return e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$blur = _e$target.blur) === null || _e$target$blur === void 0 ? void 0 : _e$target$blur.call(_e$target);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress && handleKeyPress(e);
    }
  })), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var StyledPrefixNumber = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1;\n    text-align: right;\n    opacity: 0.7;\n    white-space: nowrap;\n"])));

var StyledPrefixCountry = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-weight: 600;\n"])));

var _default = PhoneInput;
exports.default = _default;